import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import PolicyPage from "./components/policyPages/PolicyPage";
import ContactUs from "./components/contact us/ContactUs";
import { WebDataProvider } from "./Context/webDataContext";
import BlogDynamic from "./components/blog/BlogStatic";
import BlogDetailDynamic from "./components/blog/BlogDetailStatic";
import ScrollToTop from "./utils/ScrollToTop";
import ScrollToTopButton from "./utils/ScrollToTopButton";

// Analytics tracking component
function PageViewTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on route change
    if (window.gtag) {
      window.gtag('config', 'G-6274166768', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
  
  return null;
}

const AppWithRouting = () => {
  // const [isLoading, setIsLoading] = useState(true);
  // const [fadeOut, setFadeOut] = useState(false);

  // useEffect(() => {
  //   // Simulate data fetching or initial setup
  //   setTimeout(() => {
  //     setFadeOut(true);
  //     setTimeout(() => setIsLoading(false), 10); // Wait for fade-out animation
  //   }, 20); // Example: 2s loading time
  // }, []);

  return (
    <>
      {/* {isLoading ? (
        <LoadingScreen fadeOut={fadeOut} />
      ) : ( */}
        <Router>
          <ScrollToTop />
          <PageViewTracker />
          <Routes>
            <Route path="/" element={<App />} />       
            <Route path="/blog" element={<BlogDynamic />} />
            <Route path="/blog/:id" element={<BlogDetailDynamic />} />
            <Route path="/policy/:policyName" element={<PolicyPage />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
          <ScrollToTopButton />
        </Router>
      {/* )} */}
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WebDataProvider>
      <AppWithRouting />
    </WebDataProvider>
  </React.StrictMode>
);





// import React, { useEffect } from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
// import PolicyPage from "./components/policyPages/PolicyPage";
// import ContactUs from "./components/contact us/ContactUs";
// import { WebDataProvider } from "./Context/webDataContext";
// import BlogDynamic from "./components/blog/BlogStatic";
// import BlogDetailDynamic from "./components/blog/BlogDetailStatic";
// import ScrollToTop from "./utils/ScrollToTop";
// import ScrollToTopButton from "./utils/ScrollToTopButton";

// // Analytics tracking component
// function PageViewTracker() {
//   const location = useLocation();
  
//   useEffect(() => {
//     // Track page view on route change
//     if (window.gtag) {
//       window.gtag('config', 'G-XXXXXXXXXX', {
//         page_path: location.pathname + location.search,
//       });
//     }
//   }, [location]);
  
//   return null;
// }

// const AppWithRouting = () => {
//   return (
//     <Router>
//       <ScrollToTop />
//       <PageViewTracker />
//       <Routes>
//         <Route path="/" element={<App />} />
//         <Route path="/blog" element={<BlogDynamic />} />
//         <Route path="/blog/:id" element={<BlogDetailDynamic />} />
//         <Route path="/policy/:policyName" element={<PolicyPage />} />
//         <Route path="/contact" element={<ContactUs />} />
//       </Routes>
//       <ScrollToTopButton />
//     </Router>
//   );
// };

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <WebDataProvider>
//       <AppWithRouting />
//     </WebDataProvider>
//   </React.StrictMode>
// );


